export default __webpack_public_path__ + "static/Quickorder-Black-7b2d2d46532611834840d507c83569a2.png";